const solutionList = [


    {
        Title: "enterprise workshop intelligent service",
        index: 4,
        showImg: "/static/img/solution/4.jpg",
        img: [
            '12.png',
            '13.png',
            '14.png',
            '15.png',
        ],
        class: "item-a",
        info: [

            `
        <p class= "tit"> Personnel whole process intelligent management </ p>
        <p> ● Monitor and manage the activities and working status of the workshop personnel with intelligent sensors and management software </ p>
        <p> ● Improve the efficiency of personnel management, reduce human error, optimize personnel deployment, and improve production efficiency.<p>
        
        `,
            `
        <p class= "tit"> Equipment Intelligence Analysis </ p>
        <p> ● Use the Internet of Things sensors and AI algorithms to conduct real-time monitoring and data analysis on the running status of the equipment in the workshop.</p>
        <p> ● Prevent equipment failure, prolong equipment life, reduce maintenance costs, and improve the utilization rate of production equipment.</p>
        `,
            `
        <p class= "tit"> Energy intelligence optimization </ p>
        <p> ● Monitor the energy use of the workshop through the intelligent system, and provide optimization solutions.</p>
        <p> ● Reduce energy consumption, reduce carbon emissions, reduce production costs, and improve the green image of enterprises.</p>
        `,
            `
        <p class= "tit"> Personnel Behavior Operation Intelligence Analysis </ p>
        <p> ● Use the AI algorithm to analyze the operation behavior of the personnel to ensure the operation specification and safety.</p>
        <p> ● Improve operation safety, reduce accidents, and improve work efficiency and quality.</p>
        `,
        ],

    },
    {
        Title: "Enterprise-class laboratory intelligent service",
        class: "item-b",
        img: [
            '16.png',
            '17.png',
            '18.png',
            '19.png',
        ],
        index: 5,
        showImg: "/static/img/solution/4.jpg",
        info: [
            `
        <p class= "tit"> Electronic recording </ p>
        <p> ● Use the electronic experimental recording system to record every step and data in the experimental process in real time.</p>
        <p> ● Improve the accuracy and completeness of data, reduce the error and loss of paper records, and facilitate the storage and search of data.</p>
        
        `,
            `
        
        <p class= "tit"> Data Authenticity </ p>
        <p> ● uses blockchain and encryption technology to ensure the authenticity of experimental data and imtamability.</p>
        <p> ● Prevent data fraud, ensure data credibility, and meet regulatory and audit requirements.</p>
        `,
            `
        <p class= "tit"> The whole process of the experiment can be traced </ p>
        <p> ● Digital tracking of the whole process of the experiment, from the experimental design to the result analysis, each step is recorded in detail.</p>
        <p> ● Improve the transparency of experiments, facilitate problem traceability and responsibility division, and improve the level of experiment management.</p>
        
        `,
            `
        <p class= "tit"> Audit Compliance and Statistical Analysis </ p>
        <p> ● provided audit and compliance checks of experimental data and performed statistical analysis.</p>
        <p> ● Ensure experimental compliance, meet regulatory requirements, and provide valuable statistical data to support decisions.</p>
        `,
        ],
    },

    {
        Title: "scientific research-level laboratory intelligent service",
        index: 6,
        class: "item-c",
        img: [
            '21.png',
            '22.png',
            '23.png',
            '24.png',
        ],
        showImg: "/static/img/solution/4.jpg",
        info: [
            `
        <p class= "tit"> Electronic recording </ p>
        <p> ● With the enterprise-level laboratory intelligent service, record the experimental process through the electronic system.</p>
        <p> ● Improve the accuracy and efficiency of scientific research records, and facilitate data sharing and collaboration.</p>
        
        `,
            `
        
        <p class= "tit"> Experimental Project Management </ p>
        <p> ● Provide management tools for experimental projects, managing the whole process from project approval to conclusion.</p>
        <p> ● Improve the efficiency of scientific research project management, ensure that the project is planned, and facilitate resource allocation.</p>
        
        `,
            `
        <p class= "tit"> Data Authenticity and Process Traceability </ p>
        <p> ● Enterprise-level laboratory services, through technical means to ensure data authenticity and process traceability.</p>
        <p> ● Ensure the credibility of scientific research data and improve the transparency and credibility of scientific research.</p>
        
        `,
            `
        
        <p class= "tit"> Data set management and automatic training of intelligent algorithm </ p>
        <p> ● curated the experimental dataset and used intelligent algorithms for automated analysis and model training.</p>
        <p> ● Improve the utilization efficiency of scientific research data, support automatic analysis, and improve the scientific research innovation ability.</p>
        `,
        ],
    },
    {
        Title: "Medical lab intelligent service",
        index: 7,
        img: [
            '25.png',
            '26.png',
            '27.png',
            '28.png',
        ],
        class: "item-d",
        showImg: "/static/img/solution/4.jpg",
        info: [
            `
        <p class= "tit"> Intelligent Management of Patient Sample </ p>
        <p> ● uses the Internet of Things and intelligent identification technology to automate the management and tracking of patient samples.</p>
        <p> ● Improve the efficiency of sample management, reduce sample loss and confounding, and ensure the accuracy of test results.</p>
        
        `,
            `
        <p class= "tit"> Real-time monitoring of experimental data </ p>
        <p> ● Monitor the experimental data in real time through the intelligent system to ensure the accuracy and timeliness of the data.</p>
        <p> ● Improve the data processing efficiency, reduce errors, and ensure reliable experimental results.</p>
        `,
            `
        <p class= "tit"> Intelligent Analysis of the Detection Process </ p>
        <p> ● uses the AI algorithm to conduct intelligent analysis of the detection process and provide real-time feedback and optimization suggestions.</p>
        <p> ● Improve the detection efficiency and accuracy, reduce human intervention, and optimize the detection process.</p>
        `,
            `
        <p class= "tit"> Compliance and Security Guarantee </ p>
        <p> ● Use the intelligent system to ensure that the experimental process complies with industry standards and regulations and ensure data security.</p>
        <p> ● Improve compliance, ensure data security, reduce the risk of violations, and enhance the credibility of the laboratory.</p>
        `,
        ],
    },


    {
        Title: "enterprise workshop intelligent service",
        index: 4,
        showImg: "/static/img/solution/4.jpg",
        img: [
            '12.png',
            '13.png',
            '14.png',
            '15.png',
        ],
        class: "item-a",
        info: [

            `
            <p class= "tit"> Personnel whole process intelligent management </ p>
            <p> ● Monitor and manage the activities and working status of the workshop personnel with intelligent sensors and management software </ p>
            <p> ● Improve the efficiency of personnel management, reduce human error, optimize personnel deployment, and improve production efficiency.<p>
            
            `,
            `
            <p class= "tit"> Equipment Intelligence Analysis </ p>
            <p> ● Use the Internet of Things sensors and AI algorithms to conduct real-time monitoring and data analysis on the running status of the equipment in the workshop.</p>
            <p> ● Prevent equipment failure, prolong equipment life, reduce maintenance costs, and improve the utilization rate of production equipment.</p>
            `,
            `
            <p class= "tit"> Energy intelligence optimization </ p>
            <p> ● Monitor the energy use of the workshop through the intelligent system, and provide optimization solutions.</p>
            <p> ● Reduce energy consumption, reduce carbon emissions, reduce production costs, and improve the green image of enterprises.</p>
            `,
            `
            <p class= "tit"> Personnel Behavior Operation Intelligence Analysis </ p>
            <p> ● Use the AI algorithm to analyze the operation behavior of the personnel to ensure the operation specification and safety.</p>
            <p> ● Improve operation safety, reduce accidents, and improve work efficiency and quality.</p>
            `,
        ],

    },
    {
        Title: "Enterprise-class laboratory intelligent service",
        class: "item-b",
        img: [
            '16.png',
            '17.png',
            '18.png',
            '19.png',
        ],
        index: 5,
        showImg: "/static/img/solution/4.jpg",
        info: [
            `
            <p class= "tit"> Electronic recording </ p>
            <p> ● Use the electronic experimental recording system to record every step and data in the experimental process in real time.</p>
            <p> ● Improve the accuracy and completeness of data, reduce the error and loss of paper records, and facilitate the storage and search of data.</p>
            
            `,
            `
            
            <p class= "tit"> Data Authenticity </ p>
            <p> ● uses blockchain and encryption technology to ensure the authenticity of experimental data and imtamability.</p>
            <p> ● Prevent data fraud, ensure data credibility, and meet regulatory and audit requirements.</p>
            `,
            `
            <p class= "tit"> The whole process of the experiment can be traced </ p>
            <p> ● Digital tracking of the whole process of the experiment, from the experimental design to the result analysis, each step is recorded in detail.</p>
            <p> ● Improve the transparency of experiments, facilitate problem traceability and responsibility division, and improve the level of experiment management.</p>
            
            `,
            `
            <p class= "tit"> Audit Compliance and Statistical Analysis </ p>
            <p> ● provided audit and compliance checks of experimental data and performed statistical analysis.</p>
            <p> ● Ensure experimental compliance, meet regulatory requirements, and provide valuable statistical data to support decisions.</p>
            `,
        ],
    },

    {
        Title: "scientific research-level laboratory intelligent service",
        index: 6,
        class: "item-c",
        img: [
            '21.png',
            '22.png',
            '23.png',
            '24.png',
        ],
        showImg: "/static/img/solution/4.jpg",
        info: [
            `
            <p class= "tit"> Electronic recording </ p>
            <p> ● With the enterprise-level laboratory intelligent service, record the experimental process through the electronic system.</p>
            <p> ● Improve the accuracy and efficiency of scientific research records, and facilitate data sharing and collaboration.</p>
            
            `,
            `
            
            <p class= "tit"> Experimental Project Management </ p>
            <p> ● Provide management tools for experimental projects, managing the whole process from project approval to conclusion.</p>
            <p> ● Improve the efficiency of scientific research project management, ensure that the project is planned, and facilitate resource allocation.</p>
            
            `,
            `
            <p class= "tit"> Data Authenticity and Process Traceability </ p>
            <p> ● Enterprise-level laboratory services, through technical means to ensure data authenticity and process traceability.</p>
            <p> ● Ensure the credibility of scientific research data and improve the transparency and credibility of scientific research.</p>
            
            `,
            `
            
            <p class= "tit"> Data set management and automatic training of intelligent algorithm </ p>
            <p> ● curated the experimental dataset and used intelligent algorithms for automated analysis and model training.</p>
            <p> ● Improve the utilization efficiency of scientific research data, support automatic analysis, and improve the scientific research innovation ability.</p>
            `,
        ],
    },
    {
        Title: "Medical lab intelligent service",
        index: 7,
        img: [
            '25.png',
            '26.png',
            '27.png',
            '28.png',
        ],
        class: "item-d",
        showImg: "/static/img/solution/4.jpg",
        info: [
            `
            <p class= "tit"> Intelligent Management of Patient Sample </ p>
            <p> ● uses the Internet of Things and intelligent identification technology to automate the management and tracking of patient samples.</p>
            <p> ● Improve the efficiency of sample management, reduce sample loss and confounding, and ensure the accuracy of test results.</p>
            
            `,
            `
            <p class= "tit"> Real-time monitoring of experimental data </ p>
            <p> ● Monitor the experimental data in real time through the intelligent system to ensure the accuracy and timeliness of the data.</p>
            <p> ● Improve the data processing efficiency, reduce errors, and ensure reliable experimental results.</p>
            `,
            `
            <p class= "tit"> Intelligent Analysis of the Detection Process </ p>
            <p> ● uses the AI algorithm to conduct intelligent analysis of the detection process and provide real-time feedback and optimization suggestions.</p>
            <p> ● Improve the detection efficiency and accuracy, reduce human intervention, and optimize the detection process.</p>
            `,
            `
            <p class= "tit"> Compliance and Security Guarantee </ p>
            <p> ● Use the intelligent system to ensure that the experimental process complies with industry standards and regulations and ensure data security.</p>
            <p> ● Improve compliance, ensure data security, reduce the risk of violations, and enhance the credibility of the laboratory.</p>
            `,
        ],
    },

];

export default solutionList;
